import script from "./SlideBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideBar.vue?vue&type=script&setup=true&lang=ts"

import "./SlideBar.vue?vue&type=style&index=0&id=d3099b62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3099b62"]])

export default __exports__